import { render } from 'preact';
import { initAnalytics } from './analytics.ts';
import { persistToHash, readHash } from './state/store.ts';
import { App } from './ui/App.tsx';
import './ui/styles.css';

initAnalytics();
readHash();
persistToHash();

const root = document.getElementById('app');
if (!root) throw new Error('missing #app root element');
render(<App />, root);
